<template>
  <div class="wms">
    <div class="llot-top">
      <img src="../../assets/image/product/mes/mes1.svg" alt="" />
    </div>
    <div class="choose">
      <h2 class="title">{{ $t("product.mes.choose") }}</h2>
      <div class="details">
        <div class="box">
          <div class="box-top">
            <b>{{ $t("product.mes.time") }}</b>
            <span>
              <img src="../../assets/image/product/digital.svg" alt="" />
            </span>
          </div>
          <div class="box-bottom">
            {{ $t("product.mes.detailed") }}
          </div>
        </div>
        <div class="box">
          <div class="box-top">
            <b>{{ $t("product.mes.print") }}</b>
            <span>
              <img src="../../assets/image/product/clover.svg" alt="" />
            </span>
          </div>
          <div class="box-bottom">
            {{ $t("product.mes.print_detailed") }}
          </div>
        </div>
        <div class="box">
          <div class="box-top">
            <b>{{ $t("product.mes.link") }}</b>
            <span>
              <img src="../../assets/image/product/circle.svg" alt="" />
            </span>
          </div>
          <div class="box-bottom">
            {{ $t("product.mes.link_detailed") }}
          </div>
        </div>
        <div class="box">
          <div class="box-top">
            <b>{{ $t("product.mes.data") }}</b>
            <span>
              <img src="../../assets/image/product/square.svg" alt="" />
            </span>
          </div>
          <div class="box-bottom">
            {{ $t("product.mes.data_detailed") }}
          </div>
        </div>
        <div class="box">
          <div class="box-top">
            <b>{{ $t("product.mes.modular") }}</b>
            <span>
              <img src="../../assets/image/product/round.svg" alt="" />
            </span>
          </div>
          <div class="box-bottom">
            {{ $t("product.mes.modular_detailed") }}
          </div>
        </div>
        <div class="box">
          <div class="box-top">
            <b>{{ $t("product.mes.flexible") }}</b>
            <span>
              <img src="../../assets/image/product/puzzle.svg" alt="" />
            </span>
          </div>
          <div class="box-bottom">
            {{ $t("product.mes.flexible_detailed") }}
          </div>
        </div>
      </div>
    </div>
    <div class="architecture">
      <h2 class="title">{{ $t("product.mes.architecture") }}</h2>
      <span>
        {{ $t("product.mes.architecture_detailed") }}
      </span>
      <img src="../../assets/image/product/mes/mes2.svg" alt="" />
    </div>
    <div class="features">
      <h2 class="title">{{ $t("product.mes.features") }}</h2>
      <span>
        {{ $t("product.mes.features_detailed") }}
      </span>
      <img src="../../assets/image/product/mes/production.svg" alt="" />
      <img src="../../assets/image/product/mes/quality.svg" alt="" />
      <img src="../../assets/image/product/mes/engineering.svg" alt="" />
      <img src="../../assets/image/product/mes/error.svg" alt="" />
      <img src="../../assets/image/product/mes/report.svg" alt="" />
      <img src="../../assets/image/product/mes/visual.svg" alt="" />
      <img src="../../assets/image/product/mes/system.svg" alt="" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.llot {
  padding-top: 80px;
}
.llot-top > img {
  width: 100%;
}
.choose {
  margin: 60px 150px;
}
.details {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.details :nth-child(3) {
  margin-right: 0;
}
.details :nth-child(6) {
  margin-right: 0;
}
.box {
  flex: 30%;
  margin-top: 40px;
  background-color: #f7f7f7;
  height: 200px;
  border-radius: 10px;
  margin-right: 40px;
}
.box-top {
  padding-top: 30px;
  margin: 0 48px;
  font-size: 22px;
  color: #121212;
  display: flex;
}
.box-top > b {
  flex: 1;
  position: relative;
}
.box-top > span > img {
  width: 45px;
  height: 45px;
}
b:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  height: 3px;
  width: 26px;
  background-color: red;
}
.box-bottom {
  margin: 30px 100px 0 48px;
  font-size: 12px;
  color: #7e7e7c;
  line-height: 30px;
}
.architecture {
  padding: 0 150px;
  margin-top: 80px;
  background-color: #f7f7f7;
  font-size: 13px;
  color: #7e7e7c;
  line-height: 40px;
  text-align: center;
}
.architecture > .title {
  padding-top: 30px;
}
.architecture > span {
  display: block;
  margin: 35px 0;
}
.architecture > img {
  width: 100%;
  margin-bottom: 50px;
}
.features {
  padding: 0 150px;
  margin-top: 80px;
  background-color: #f7f7f7;
  font-size: 14px;
  color: #7e7e7c;
  line-height: 40px;
  text-align: center;
  background-image: url("../../assets/image/product/back.png");
  background-size: cover;
  background-size: 100% 100%;
  margin-bottom: 80px;
}
.features > span {
  display: block;
  margin: 30px 0;
}
.features > img {
  margin-bottom: 60px;
}
/* 标题 */
.title {
  text-align: center;
  font-size: 26px;
  color: #121212;
  line-height: 45px;
  position: relative;
}
h2:after {
  content: "";
  position: absolute;
  left: 49%;
  bottom: 0;
  height: 3px;
  width: 25px;
  background-color: red;
}
</style>